import {combineReducers} from "redux";
import AccountReducer, {IAccountReducerState} from "./account.reducer";
import NavigationReducer, {INavigationReducerState} from "./navigation.reducer";
import StaticDataReducer, {IStaticDataReducerState} from "./static-data.reducer";
import UserReducer, {IUserReducerState} from "./user.reducer";
import ClientReducer, {IClientReducerState} from "./client.reducer";
import StateManagementReducer, {IStateManagementReducerState} from "./state-management.reducer";
import FormReducer, {IFormStateReducerState} from "./form-state.reducer";
import DashboardReducer, {IDashboardReducerState} from "./dashboard.reducer";

export interface IRootReducerState {
    account: IAccountReducerState,
    navigation: INavigationReducerState,
    staticData: IStaticDataReducerState,
    client: IClientReducerState,
    user: IUserReducerState,
    stateManagement: IStateManagementReducerState,
    formState: IFormStateReducerState,
    dashboard:IDashboardReducerState
}

const rootReducer = combineReducers({
    account: AccountReducer,
    navigation: NavigationReducer,
    staticData: StaticDataReducer,
    user: UserReducer,
    client: ClientReducer,
    stateManagement: StateManagementReducer,
    formState: FormReducer,
    dashboard:DashboardReducer
});

export default rootReducer;
